<template>
  <b-modal
    ref="modal"
    id="send-message-modal"
    title="Decline Session Request"
  >
    <form-component>
      <p>Please provide a reason for declining this session request. The student will be notified of this reason.</p>
      <form novalidate="novalidate">
        <input-text-area
          id="message"
          v-model="message"
          v-validate="'required'"
          name="message"
          data-vv-name="message"
          data-vv-as="message"
          label="Your Message"
          type="text"
          required
          :error="errors.first('message')"
        />
      </form>
    </form-component>

    <template
      slot="modal-footer"
      slot-scope="{ ok, cancel }"
    >
      <button
        class="btn"
        type="button"
        @click="hide()"
      >
        Cancel
      </button>
      <button
        class="btn btn--primary"
        type="button"
        :disabled="saving"
        @click="save()"
      >
        <font-awesome-icon
          v-if="saving"
          :spin="true"
          :icon="['fas', 'spinner']"
          class="icon alt"
        />
        <span v-else>Decline Session</span>
      </button>
    </template>
  </b-modal>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';
import SessionClient from '@/api/SessionClient';

export default {
  name: 'RejectPendingModal',
  components: {
    FormComponent,
    InputTextArea,
  },
  data() {
    return {
      sessionsClient: new SessionClient(this.$http),
      message: '',
      request: null,
      saving: false,
    };
  },
  props: {
    onReject: {
      type: Function,
    },
  },
  methods: {
    show(request, prefilledMessage) {
      this.request = request || null;
      this.message = prefilledMessage || '';
      this.saving = false;

      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },

    async save() {
      const result = await this.$validator.validateAll()
      if (!result) 
        return;

      this.errors.clear();
      this.saving = true;

      try {
        await this.sessionsClient.declineRequest(this.request.id, this.message)
        this.saving = false;
        this.hide();
        this.onReject(this.request);
      } catch(ex) {
        this.saving = false;
        this.$store.commit('setGlobalAlert', {
          msg: 'Failed to respond to request. Please try again!', error: true,
        });
      };
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
